import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50" data-testid="protected-route-loading-state">
        <div className="text-center space-y-3">
          <div className="w-12 h-12 rounded-full border-4 border-t-transparent animate-spin mx-auto" style={{ borderColor: '#53a5ca', borderTopColor: 'transparent' }} />
          <p className="text-sm text-gray-600">Checking dashboard access…</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};